<template>
  <Record
    class="ArticleContainingLaptop"
    :title="article.topic">
    <Set icon="info" :label="$t('articleTitle')">
      {{ article.title }}
    </Set>
    <Row>
      <Column :xs="6">
        <Set icon="info" :label="$t('priceInArticle')">
          {{ articleLaptop.price }}
        </Set>
      </Column>
      <Column :xs="6">
        <Set icon="info" :label="$t('priceCurrent')">
          {{ currentPrice || 'Null' }}
        </Set>
      </Column>
    </Row>
    <div slot="actions" class="actionsWithTags">
      <Route
        :id="article.id"
        class="Btn ib sm info inv"
        :to="{ name: 'Article', hash: `#RecordArticleLaptop-${laptopId}` }">
        {{ $t('viewArticle') }}
      </Route>
    </div>
  </Record>
</template>

<script>
import { getters } from '@utils'

export default {
  props: {
    articleLaptopWithArticle: Object,
    currentPrice: Number,
    laptopId: Number,
  },
  computed: {
    article() {
      return this.articleLaptopWithArticle.article
    },
    articleLaptop() {
      return this.articleLaptopWithArticle.articleLaptop
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.ArticleContainingLaptop {
  .actionsWithTags {
    .RecordActions {
      float: left;
    }

    .Tag {
      margin-left: 0.5rem;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "link": "View on Amazon",
    "articleTitle": "Title",
    "viewArticle": "View in article",
    "priceInArticle": "Price in article",
    "priceCurrent": "Current price"
  }
}
</i18n>
